module.exports = is;